import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Mail } from 'lucide-react';

const EmailSyncTab = () => {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Email Server Contact Sync</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Import contacts from Gmail, Outlook, or other email providers.
          </p>

          <div className="grid grid-cols-2 gap-4 pt-4">
            {/* Gmail */}
            <Card>
              <CardContent className="p-6 text-center">
                <Mail className="w-12 h-12 mx-auto mb-3 text-muted-foreground" />
                <h3 className="font-semibold mb-2">Gmail Contacts</h3>
                <p className="text-xs text-muted-foreground mb-4">
                  Import via Google Contacts API
                </p>
                <Button variant="outline" disabled>
                  Coming Soon
                </Button>
              </CardContent>
            </Card>

            {/* Outlook */}
            <Card>
              <CardContent className="p-6 text-center">
                <Mail className="w-12 h-12 mx-auto mb-3 text-muted-foreground" />
                <h3 className="font-semibold mb-2">Outlook Contacts</h3>
                <p className="text-xs text-muted-foreground mb-4">
                  Import via Microsoft Graph API
                </p>
                <Button variant="outline" disabled>
                  Coming Soon
                </Button>
              </CardContent>
            </Card>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default EmailSyncTab;
